<div class="ns-tab-page unsub-page">
  <p class="ns-banner ns-banner--error" *ngIf="loadError">
    {{ loadError }}
    <button type="button" class="ns-link-btn" (click)="load()">Retry</button>
  </p>

  <div class="ns-tpl-loader" *ngIf="loading">
    <app-ltms-loader></app-ltms-loader>
  </div>

  <ng-container *ngIf="!loading && !loadError">
    <section class="bl-hero unsub-hero">
      <div class="bl-hero__top">
        <div class="bl-hero__brand">
          <span class="unsub-hero__mark" aria-hidden="true">
            <i class="fa fa-ban"></i>
          </span>
          <div>
            <h2>Unsubscribe list</h2>
            <p>Customers who opted out of invitations and reminders for this project.</p>
          </div>
        </div>
      </div>

      <div class="unsub-hero__grid">
        <article class="bl-metric unsub-stat">
          <span class="bl-metric__label">Unsubscribed</span>
          <strong class="unsub-stat__value" *ngIf="totalKnown">{{ displayedTotal | number }}</strong>
          <button
            type="button"
            class="unsub-stat__load"
            *ngIf="canLoadTotal"
            [class.is-loading]="totalLoading"
            [disabled]="totalLoading"
            (click)="loadTotal()"
          >
            <span class="unsub-stat__spinner" *ngIf="totalLoading" aria-hidden="true"></span>
            {{ totalLoading ? 'Counting…' : 'Load total' }}
          </button>
          <p *ngIf="totalKnown">{{ unsubscribedCaption }}</p>
          <p *ngIf="canLoadTotal">{{ totalLoading ? 'Adding up the list…' : 'There are more than this page. Load the total when you need it.' }}</p>
        </article>
        <article class="bl-metric">
          <span class="bl-metric__label">How it works</span>
          <p>Customer Notifier checks the user record before a send. Anyone on this list is skipped for this project only.</p>
        </article>
        <article class="bl-metric">
          <span class="bl-metric__label">Restore sending</span>
          <p>Remove a row to let that customer receive invitations from this project again. Search by email, customer ID, phone, or WhatsApp — type the complete value and press Enter.</p>
        </article>
      </div>
    </section>

    <div class="version-history-container">
      <div class="search-pagination-container">
        <div class="drafts-header">
          <h3>Customers</h3>
        </div>
        <div class="pagination-controls">
          <div class="bl-search unsub-search">
            <div class="search-box" [class.unsub-search--open]="showSearchFields">
              <i class="fa fa-search search-icon"></i>
              <input
                type="text"
                [(ngModel)]="listSearchQuery"
                name="unsubSearchQuery"
                [placeholder]="searchPlaceholder"
                [title]="'Enter the complete ' + selectedSearchField.field_text + ' and press Enter'"
                (ngModelChange)="onListSearchQueryChange()"
                (keyup.enter)="applyListSearch()"
                autocomplete="off"
              >
              <button type="button" class="clear-button" *ngIf="listSearchQuery" (click)="clearListSearch()">
                <i class="fa fa-times"></i>
              </button>
              <button type="button" class="unsub-search__fields-btn" (click)="toggleSearchFields($event)" aria-label="Choose search field">
                <img src="assets/images/menu-down-dark.svg" alt="">
              </button>
            </div>
            <ul class="unsub-search__list" *ngIf="showSearchFields">
              <li
                *ngFor="let field of searchFields"
                [class.is-active]="field.field_id === selectedSearchField.field_id"
                (click)="chooseSearchField(field)"
              >
                {{ field.field_text }}
              </li>
            </ul>
            <p class="bl-search__hint" *ngIf="searchNeedsEnter">Enter the complete value and press Enter</p>
          </div>
            <button type="button" (click)="goToFirstPage()" [disabled]="page <= 1 || entriesLoading || !pageTotal">
              <img src="assets/images/chevron-double-left.svg" alt="First">
            </button>
            <button type="button" (click)="previousPage()" [disabled]="page <= 1 || entriesLoading || !pageTotal">
              <img src="assets/images/chevron-left.svg" alt="Previous">
            </button>
            <div class="pagination-text">
              {{ rangeStart }} - {{ rangeEnd }}<ng-container *ngIf="pageTotalKnown"> of {{ pageTotal }}</ng-container>
            </div>
            <button type="button" (click)="nextPage()" [disabled]="page >= pageCount || entriesLoading || !pageTotal">
              <img src="assets/images/chevron-right.svg" alt="Next">
            </button>
            <button type="button" (click)="goToLastPage()" [disabled]="page >= pageCount || entriesLoading || !pageTotal || !canGoLastPage">
              <img src="assets/images/chevron-double-right.svg" alt="Last">
            </button>
        </div>
      </div>

      <div class="table-responsive version-table" *ngIf="entries.length || entriesLoading">
        <div class="table-overlay" *ngIf="entriesLoading">
          <app-ltms-loader></app-ltms-loader>
        </div>
        <table class="unsub-table">
          <thead>
            <tr>
              <th>Customer</th>
              <th>Contact</th>
              <th>IP address</th>
              <th>Unsubscribed On</th>
              <th class="action-header-cell">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of entries">
              <td>
                <div class="unsub-cell">
                  <strong>{{ displayName(row) }}</strong>
                  <small *ngIf="row.customer_id">{{ row.customer_id }}</small>
                  <small *ngIf="!row.customer_id">No customer ID</small>
                </div>
              </td>
              <td>
                <div class="unsub-cell">
                  <span>{{ row.email_address || '—' }}</span>
                  <small>{{ contactLine(row) }}</small>
                </div>
              </td>
              <td class="unsub-mono">{{ row.ip_address || '—' }}</td>
              <td class="ns-nowrap">{{ unsubscribedOn(row) ? (unsubscribedOn(row) | date: 'dd-MMM-yy HH:mm') : '—' }}</td>
              <td class="action-column-cell">
                <button
                  type="button"
                  class="restore-button"
                  [class.is-unauthorized]="!isWriteAllowed"
                  (click)="askRemove(row)"
                >
                  Remove
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="no-data-container" *ngIf="!entries.length && !entriesLoading">
        <div class="no-data-message">No unsubscribed customers for this project yet.</div>
      </div>
    </div>
  </ng-container>
</div>

<div class="ns-confirm" *ngIf="confirmRemove">
  <div class="ns-confirm__overlay" (click)="confirmRemove = null"></div>
  <div class="ns-confirm__card">
    <h3>Allow invitations again?</h3>
    <p>
      {{ displayName(confirmRemove) }}
      {{ confirmRemove.email_address ? '· ' + confirmRemove.email_address : '' }}
      will be taken off this project's unsubscribe list. Customer Notifier will send to them again.
    </p>
    <div class="ns-confirm__actions">
      <button type="button" class="ns-save ns-save--ghost" (click)="confirmRemove = null">Don't continue</button>
      <button type="button" class="ns-save" (click)="confirmRemoveNow()">Yes, continue</button>
    </div>
  </div>
</div>
